export default __webpack_public_path__ + "static/treneri-milos-tancibudek-778cba0d6a7df8be57b80017d27c9318.jpg";